<template>
    <div id="contendor-principal-notificadores" class="container-fluid">
        <!-- <div id="contenedor-encabezados-notificadores" class="text-left">
            <h1>Notificadores</h1>
            ELIMINAR <h3>Ingrese la información requerida para filtrar los notificadores</h3>
        </div>
        <div id="encabezado-contenedor-contenido" class="form-inline mt-3">
            <div class="flex-grow-1 pl-3"><h4>Administración de notificadores</h4></div>
        </div> 
        <div id="contendor-notificadores">
            <div class="area col-12">
                ELIMINAR <h5>Administracion de notificadores</h5>
                ELIMINAR <hr />
                ELIMINAR <h3>Ingrese la información requerida para registrar o buscar los notificadores</h3>
                <div class="contenedor-color-negro mt-2">
                     <div v-if="!usuarioEsDeJuzgadoMixto" class="d-flex justify-content-end mb-4">
                        <button type="button" @click="eventoFiltrarNotificadores" id="btn-datos-plantilla" class="btn btn-primary"><i class="fas fa-search"></i>&nbsp;&nbsp;Realizar búsqueda</button>
                    </div>
                    <div id="contenedor-opciones-busqueda">
                        <div v-if="!usuarioEsDeJuzgadoMixto" class="form-group" style=" margin-right: 1em; width: 25%;">
                            <h6>Zona</h6>
                            <C021Zonas class="p-0 m-0" v-on:valorParaElPadre="cambioTipoDeZona" 
                                       :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                       :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                       :idDelInput="'catalogoZonasNotificadoresFiltro'" 
                                       :parametros="{ZonaId: null,ConInactivas: false,ConPoligonos: false,ConNotificadores: false}"
                                       :valorDefinido="tipoZonaId"></C021Zonas>
                        </div>
                        <div class="form-group" style=" margin-right: 1em; width: 25%;">
                            <h6>Nombre</h6>
                            <input type="text" placeholder="Ingrese el nombre del notificador" v-model="nombreFiltro" class="form-control" />
                        </div>
                        <div class="form-group" style=" margin-right: 1em; width: 25%;">
                            <h6>Apellido paterno</h6>
                            <input type="text" placeholder="Ingrese el apellido paterno del notificador" v-model="apellidoPaternoFiltro" class="form-control" />
                        </div>
                        <div class="form-group" style="width: 25%;">
                            <h6>Apellido materno</h6>
                            <input type="text" placeholder="Ingrese el apellido materno del notificador" v-model="apellidoMaternoFiltro" class="form-control" />
                        </div>
                        <div v-if="usuarioEsDeJuzgadoMixto" class="form-group align-self-end" style=" margin-left: 2em; width: 25%;">
                            <button type="button" @click="eventoFiltrarNotificadores" id="btn-datos-plantilla" class="btn btn-primary"><i class="fas fa-search"></i>&nbsp;&nbsp;Realizar búsqueda</button>
                        </div>
                    </div>
                    <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;"/>
                    <div>
                         <div id="inputs-filtro-memoria" class="form-inline justify-content-end">
                            <h6 for="f-busqueda" class="mr-sm-2">Buscar:</h6>
                            <input v-model="tablaNotificadores.buscarPor" type="text" id="f-busqueda" placeholder="Buscar en todas las columnas" class="form-control"/>
                        </div>
                        <div id="titulo-tabla">
                            <h4>Lista de notificadores</h4>
                            <button id="btn-agregar-nuevoNotififcador" type="button" @click="agregarNotificador(true)" class="btn btn-primary"><i class="fas fa-plus-circle"></i>&nbsp;&nbsp;Agregar</button> 
                        </div>
                        <CTablaGenericaCedulas v-if="listaDeNotificadores.length > 0" class="table-responsive"
                            :idDelInput="ID_TABLA_NOTIFICADORES"
                            :encabezadosColumnas="encabezadosColumnas"
                            :accionesEnTabla="TABLA_NOTIFICADORES_ACCIONES"
                            v-on:accionesFuncionDeEditar="editarNotificador"
                            v-on:accionFuncionEliminar="eventoEliminarNotificador"
                            :listaDeCedulas="listaDeNotificadores"></CTablaGenericaCedulas>
                             <div v-if="listaDeNotificadores.length < 1 && !cargandoNotificadores" class="contenedor-sin-notificadores" >
                                <div class="text-center">
                                    <i class="fas fa-user-slash" style="font-size: 9em;"></i>
                                    <h6 style="margin-top:2em;">No se encontraron notificadores</h6>
                                </div>
                            </div>
                            <div v-if="cargandoNotificadores" class="contenedor-cargando" style="height: 300px ;">
                                <div class="text-center">
                                    <i class="fas fa-spinner fa-spin fa-5x"></i>
                                    <h4 class="mt-4">Cargando notificadores</h4>
                                </div>
                            </div>
                    </div>
                     FORMULARIO DE Notificador
                    <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="formularo-notificador">
                        <div class="modal-dialog modal-lg modal-dialog-centered">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Formulario para registro de notificador</h5>
                                    <button @click="limpiarVariablesFormularioAlta" id="btn-cerrar-formulario-alta-notificador" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                                </div>
                                <div class="modal-body pl-4 pr-4">
                                    <div id="contenedor-error-formulario" v-if="mostrarErroresFormularioAlta && mostrarAvisoErrores">
                                        <h6><i class="fas fa-exclamation-triangle text-danger"></i>&nbsp;Error en Formulario</h6>
                                        <span style="text-align: justify; display:block;">{{mensajeErrorFormularioAlta}}</span>
                                    </div>
                                    <div>                                        
                                        <span style="text-align: justify; display:block;">El notificador a agregar debe ser usuario del sistema.</span>
                                    </div>
                                    <div v-show="!mostrarTablaUsuarios" class="contenedor-color-negro" style="margin-top:1.5em;">
                                        <div>
                                            <h6>Dirección de notificación a la que corresponde&nbsp;
                                                <i v-if="mostrarErroresFormularioAlta && areaNoticadorEsValida" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                                <i v-if="mostrarErroresFormularioAlta && !areaNoticadorEsValida" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                            <C001Area :class="[areaEsInformativa ? 'catalogoInformativo p-0 m-0' : 'p-0 m-0']" v-if="!ocultarCatalogo" v-on:valorParaElPadre="cambioDeAreaAlta" 
                                                      :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                                      :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                                      :idDelInput="'TipoAreaAltaNotificador'" 
                                                      :parametros="{}" 
                                                      :valorDefinido="tipoAreaId" 
                                                      :key="'CAreaA' + contadorRenderCatalogos"></C001Area>
                                        </div>
                                        <div style="margin-top:1em;">
                                            <h6>Nombre&nbsp;
                                                <i v-if="mostrarErroresFormularioAlta && this.validacionFormularioAlta(true,false)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                                <i v-if="mostrarErroresFormularioAlta && !this.validacionFormularioAlta(true,false)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                            <input id="nombreF" type="text" placeholder="Ingrese el nombre del notificador/a" v-model="nombreNotificador" :class="[mostrarErroresFormularioAlta && !this.validacionFormularioAlta(true,false) ? 'form-control border border-danger' : 'form-control']" />
                                        </div>
                                        <div style="margin-top:1em;">
                                            <h6>Apellido paterno&nbsp;
                                                <i v-if="mostrarErroresFormularioAlta && this.validacionFormularioAlta(true,false)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                                <i v-if="mostrarErroresFormularioAlta && !this.validacionFormularioAlta(true,false)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                            <input id="apellidoPF" type="text" placeholder="Ingrese el apellido paterno" v-model="apellidoPaterno" :class="[mostrarErroresFormularioAlta && !this.validacionFormularioAlta(true,false) ? 'form-control border border-danger' : 'form-control']" />
                                        </div>
                                        <div style="margin-top:1em;">
                                            <h6>Apellido materno&nbsp;
                                                <i v-if="mostrarErroresFormularioAlta && this.validacionFormularioAlta(true,false)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                                <i v-if="mostrarErroresFormularioAlta && !this.validacionFormularioAlta(true,false)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                            <input id="apellidoMF" type="text" placeholder="Ingrese el apellido materno" v-model="apellidoMaterno" :class="[mostrarErroresFormularioAlta && !this.validacionFormularioAlta(true,false) ? 'form-control border border-danger' : 'form-control']" />
                                        </div>
                                        <div v-if="!usuarioEsDeJuzgadoMixto" style="margin-top:1em;">
                                            <h6>Asignar a la zona</h6>
                                             <C021Zonas  v-if="!ocultarCatalogo" class="p-0 m-0" v-on:valorParaElPadre="cambioTipoDeZona" 
                                                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                                        :idDelInput="'catalogoZonasNotificadoresAlta'" 
                                                        :parametros="{ZonaId: null,ConInactivas: false,ConPoligonos: false,ConNotificadores: false}"
                                                        :valorDefinido="tipoZonaId"
                                                        :key="'CZonasFormA' + contadorRenderCatalogos"></C021Zonas>
                                        </div>
                                         ELIMINAR INICIO  <div v-if="modoEdicion" style="margin-top:1em;">
                                            <h6>Estatus</h6>
                                           
                                            <select v-model="estatusNotificador" class="form-control">
                                                <option value="-1">Eliga un estatus</option>
                                                <option value="1">Activo</option>
                                                <option value="0">Inactivo</option>
                                            </select> 
                                        </div> ELIMINAR FIN
                                    </div>
                                    <div v-if="mostrarTablaUsuarios && !modoEdicion" id="tabla-usuarios-registrados" class="contenedor-color-negro" style="margin-top:1.5em;">
                                        <h5>Seleccione a la persona</h5>
                                        <hr />
                                        <table id="tablaUsuarios" class="table table-dark" style="width: 100%; heigth: 100%">
                                            <thead>
                                                <tr>
                                                <th class="encabezados-listado text-center" scope="col">Nombre</th>
                                                <th class="encabezados-listado text-center" scope="col">Apellido paterno</th>
                                                <th class="encabezados-listado text-center" scope="col">Apellido materno</th>
                                                <th class="encabezados-listado text-center" scope="col"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(datosPersonal,index) in obtenerPaginacionDePersonal" :key="'personal' + index">
                                                    <td v-for="(datos,index) in contenidoColumnasPersonal(datosPersonal)" class="text-center" :key="'columna' + index" v-html="datos"></td>
                                                    <td class="text-center mx-auto">
                                                        <input :id="'tabla-partes' + '-check-' + datosPersonal.id" type="checkbox" class="form-check-input" @change="eventoNotificadorSeleccionada($event)">
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                         <nav id="paginacion-tabla-personal-notificadores">
                                            <ul class="pagination justify-content-end">
                                                <li class="page-item">
                                                    <button id="opcionInicio" type="button" class="page-link" v-if="pagina != 1" @click="cambioDePaginaConOpcion($event)"> Anterior </button>
                                                </li>
                                                <li :id="'tabla-personal-notificadores' + 'pagina'+ numeroDePagina" class="page-item" v-for="(numeroDePagina,index) in numeroDePaginas" :key="'pagina' + index">
                                                    <button type="button" class="page-link active" @click="cambioDePaginaConPuntero(numeroDePagina)"> {{numeroDePagina}} </button>
                                                </li>
                                                <li class="page-item">
                                                    <button id="opcionSiguiente" type="button" @click="cambioDePaginaConOpcion($event)" v-if="pagina < numeroDePaginas.length" class="page-link"> Siguiente </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                    <div :class="[mostrarTablaUsuarios ? 'd-flex justify-content-between' : 'd-flex justify-content-end']" style="margin-top: 2em;">
                                         <button v-if="mostrarTablaUsuarios" class="btn btn-primary" @click="regresarVistaAnterior"><i class="fas fa-long-arrow-alt-left"></i></button>
                                         <button v-if="!mostrarTablaUsuarios" class="btn btn-primary" @click="eventoGuardarNotififcador"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                                    </div>
                                </div>             
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>-->
        <!-- NUEVO LAYOUT -->
        <div id="encabezados-tp">
            <h1>Notificadores</h1>
            <h3>Da de alta, modifica o elimina a los notificadores del sistema</h3>
            <div class="hr-titulo"></div>
        </div>
        <!-- SECCION DE ADMINISTRACION -->
        <div class="card" style="margin-top: 3em;">
            <div class="card-header">
                <h5><strong>Notificadores registrados en el sistema</strong></h5>
            </div>
            <div class="card-body">
                <div class="row pr-3 pl-4 pt-2">
                    <!-- SECCION FILTROS DE BUSQUEDA -->
                    <div class="row no-gutters col-xs-12 col-sm-12 col-md-12 col-lg-12 contenedor-color-negro">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pb-3">
                            <h5><strong>Filtros de busqueda</strong></h5>
                        </div>
                        <div v-if="!usuarioEsDeJuzgadoMixto" class="row no-gutters col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pb-1">
                            <div class="form-group col-xs-6 col-sm-6 col-md-6 col-lg-6">
                                <h6>Zona</h6>
                                <C021Zonas class="p-0 m-0" v-on:valorParaElPadre="cambioTipoDeZona" 
                                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                        :idDelInput="'catalogoZonasNotificadoresFiltro'" 
                                        :parametros="{ZonaId: null,ConInactivas: false,ConPoligonos: false,ConNotificadores: false}"
                                        :valorDefinido="tipoZonaId"></C021Zonas>
                            </div>
                        </div>
                        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-2">
                            <div class="form-group">
                                <h6>Nombre</h6>
                                <input type="text" placeholder="Ingrese el nombre del notificador" v-model="nombreFiltro" class="form-control" />
                            </div>
                        </div>
                        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-2">
                            <div class="form-group">
                                <h6>Apellido paterno</h6>
                                <input type="text" placeholder="Ingrese el apellido paterno del notificador" v-model="apellidoPaternoFiltro" class="form-control" />
                            </div>
                        </div>
                        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-2">
                            <div class="form-group">
                                <h6>Apellido materno</h6>
                                <input type="text" placeholder="Ingrese el apellido materno del notificador" v-model="apellidoMaternoFiltro" class="form-control" />
                            </div>
                        </div>
                        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-2 align-self-end">
                            <div class="form-group d-flex justify-content-end">
                                <button type="button" @click="eventoFiltrarNotificadores" id="btn-datos-plantilla" class="btn btn btn-primary"><i class="fas fa-search"></i>&nbsp;&nbsp;Realizar búsqueda</button>
                            </div>
                        </div>
                    </div>
                    <!-- SECCION CRUD NOTIFICADORES -->
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-0 pr-0 pt-0" style="margin-top:2em;">
                        <div>
                            <div id="titulo-tabla" class="row no-gutters align-items-center">
                                <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-2 pt-1">
                                    <h5><strong>Lista de notificadores</strong></h5>
                                </div>
                                <div class="row no-gutters col-xs-8 col-sm-8 col-md-8 col-lg-8 pr-2 pt-1">
                                    <div id="inputs-filtro-memoria" class="col-xs-8 col-sm-8 col-md-8 col-lg-8 pr-1 pt-2 d-flex justify-content-end">
                                        <input v-model="tablaNotificadores.buscarPor" type="text" id="f-busqueda" placeholder="Buscar en todas las columnas" class="form-control"/>
                                    </div>
                                    <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-1 pt-2 d-flex align-items-center justify-content-end">
                                        <div v-if="listaDeNotificadores.length > 0" style="border-left: 2px solid #3d3d3d;height: 2.7em; margin-right: 1em;"></div>
                                        <button id="btn-agregar-nuevoNotififcador" type="button" @click="agregarNotificador(true)" class="btn btn-primary"><i class="fas fa-plus-circle"></i>&nbsp;&nbsp;Agregar</button> 
                                    </div>
                                </div>
                            </div>
                            <CTablaGenericaCedulas v-if="listaDeNotificadores.length > 0" class="table-responsive"
                                :idDelInput="ID_TABLA_NOTIFICADORES"
                                :encabezadosColumnas="encabezadosColumnas"
                                :accionesEnTabla="TABLA_NOTIFICADORES_ACCIONES"
                                v-on:accionesFuncionDeEditar="editarNotificador"
                                v-on:accionFuncionEliminar="eventoEliminarNotificador"
                                :listaDeCedulas="listaDeNotificadores"></CTablaGenericaCedulas>
                                <div v-if="listaDeNotificadores.length < 1 && !cargandoNotificadores" class="contenedor-sin-notificadores" >
                                    <div class="text-center">
                                        <i class="fas fa-user-slash" style="font-size: 9em;"></i>
                                        <h6 style="margin-top:2em;">No se encontraron notificadores</h6>
                                    </div>
                                </div>
                                <div v-if="cargandoNotificadores" class="contenedor-cargando" style="height: 300px ;">
                                    <div class="text-center">
                                        <i class="fas fa-spinner fa-spin fa-5x"></i>
                                        <h4 class="mt-4">Cargando notificadores</h4>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- FORMULARIO DE Notificador -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="formularo-notificador">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Formulario para registro de notificador</h5>
                        <button @click="limpiarVariablesFormularioAlta" id="btn-cerrar-formulario-alta-notificador" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div id="contenedor-error-formulario" v-if="mostrarErroresFormularioAlta && mostrarAvisoErrores">
                            <h6><i class="fas fa-exclamation-triangle text-danger"></i>&nbsp;Error en Formulario</h6>
                            <span style="text-align: justify; display:block;">{{mensajeErrorFormularioAlta}}</span>
                        </div>
                        <div>                                        
                            <span style="text-align: justify; display:block;">El notificador a agregar debe ser usuario del sistema.</span>
                        </div>
                        <div v-show="!mostrarTablaUsuarios" class="contenedor-color-negro" style="margin-top:1.5em;">
                            <div>
                                <h6>Dirección de notificación a la que corresponde&nbsp;
                                    <i v-if="mostrarErroresFormularioAlta && areaNoticadorEsValida" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="mostrarErroresFormularioAlta && !areaNoticadorEsValida" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <C001Area :class="[areaEsInformativa ? 'catalogoInformativo p-0 m-0' : 'p-0 m-0']" v-if="!ocultarCatalogo" v-on:valorParaElPadre="cambioDeAreaAlta" 
                                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                            :idDelInput="'TipoAreaAltaNotificador'" 
                                            :parametros="{}" 
                                            :valorDefinido="tipoAreaId" 
                                            :key="'CAreaA' + contadorRenderCatalogos"></C001Area>
                            </div>
                            <div style="margin-top:1em;">
                                <h6>Nombre&nbsp;
                                    <i v-if="mostrarErroresFormularioAlta && this.validacionFormularioAlta(true,false)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="mostrarErroresFormularioAlta && !this.validacionFormularioAlta(true,false)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <input id="nombreF" type="text" placeholder="Ingrese el nombre del notificador/a" v-model="nombreNotificador" :class="[mostrarErroresFormularioAlta && !this.validacionFormularioAlta(true,false) ? 'form-control border border-danger' : 'form-control']" />
                            </div>
                            <div style="margin-top:1em;">
                                <h6>Apellido paterno&nbsp;
                                    <i v-if="mostrarErroresFormularioAlta && this.validacionFormularioAlta(true,false)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="mostrarErroresFormularioAlta && !this.validacionFormularioAlta(true,false)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <input id="apellidoPF" type="text" placeholder="Ingrese el apellido paterno" v-model="apellidoPaterno" :class="[mostrarErroresFormularioAlta && !this.validacionFormularioAlta(true,false) ? 'form-control border border-danger' : 'form-control']" />
                            </div>
                            <div style="margin-top:1em;">
                                <h6>Apellido materno&nbsp;
                                    <i v-if="mostrarErroresFormularioAlta && this.validacionFormularioAlta(true,false)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="mostrarErroresFormularioAlta && !this.validacionFormularioAlta(true,false)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <input id="apellidoMF" type="text" placeholder="Ingrese el apellido materno" v-model="apellidoMaterno" :class="[mostrarErroresFormularioAlta && !this.validacionFormularioAlta(true,false) ? 'form-control border border-danger' : 'form-control']" />
                            </div>
                            <div v-if="!usuarioEsDeJuzgadoMixto" style="margin-top:1em;">
                                <h6>Asignar a la zona</h6>
                                    <C021Zonas  v-if="!ocultarCatalogo" class="p-0 m-0" v-on:valorParaElPadre="cambioTipoDeZona" 
                                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                            :idDelInput="'catalogoZonasNotificadoresAlta'" 
                                            :parametros="{ZonaId: null,ConInactivas: false,ConPoligonos: false,ConNotificadores: false}"
                                            :valorDefinido="tipoZonaId"
                                            :key="'CZonasFormA' + contadorRenderCatalogos"></C021Zonas>
                            </div>
                            <div v-if="esDireccionCiviles" style="margin-top:1em;">
                                <h6>
                                    Notificador asignado para las órdenes de protección
                                </h6>
                                    <select id="esOrdenDeProteccion_Select" class="form-control p-0 m-0" v-model="esOrdenDeProteccion">                                         
                                    <option value="false">&nbsp;&nbsp; No </option>
                                    <option value="true">&nbsp;&nbsp; Si </option>                                            
                                </select>
                            </div> 
                                <!-- <div v-if="modoEdicion" style="margin-top:1em;">
                                <h6>Estatus</h6>
                                
                                <select v-model="estatusNotificador" class="form-control">
                                    <option value="-1">Eliga un estatus</option>
                                    <option value="1">Activo</option>
                                    <option value="0">Inactivo</option>
                                </select> 
                            </div> -->
                        </div>
                        <div v-if="mostrarTablaUsuarios && !modoEdicion" id="tabla-usuarios-registrados" class="contenedor-color-negro" style="margin-top:1.5em;">
                            <h5>Seleccione a la persona</h5>
                            <hr />
                            <table id="tablaUsuarios" class="table table-dark" style="width: 100%; heigth: 100%">
                                <thead>
                                    <tr>
                                    <th class="encabezados-listado text-center" scope="col">Nombre</th>
                                    <th class="encabezados-listado text-center" scope="col">Apellido paterno</th>
                                    <th class="encabezados-listado text-center" scope="col">Apellido materno</th>
                                    <th class="encabezados-listado text-center" scope="col"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(datosPersonal,index) in obtenerPaginacionDePersonal" :key="'personal' + index">
                                        <td v-for="(datos,index) in contenidoColumnasPersonal(datosPersonal)" class="text-center" :key="'columna' + index" v-html="datos"></td>
                                        <td class="text-center mx-auto">
                                            <input :id="'tabla-partes' + '-check-' + datosPersonal.id" type="checkbox" class="form-check-input" @change="eventoNotificadorSeleccionada($event)">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                                <nav id="paginacion-tabla-personal-notificadores">
                                <ul class="pagination justify-content-end">
                                    <li class="page-item">
                                        <button id="opcionInicio" type="button" class="page-link" v-if="pagina != 1" @click="cambioDePaginaConOpcion($event)"> Anterior </button>
                                    </li>
                                    <li :id="'tabla-personal-notificadores' + 'pagina'+ numeroDePagina" class="page-item" v-for="(numeroDePagina,index) in numeroDePaginas" :key="'pagina' + index">
                                        <button type="button" class="page-link active" @click="cambioDePaginaConPuntero(numeroDePagina)"> {{numeroDePagina}} </button>
                                    </li>
                                    <li class="page-item">
                                        <button id="opcionSiguiente" type="button" @click="cambioDePaginaConOpcion($event)" v-if="pagina < numeroDePaginas.length" class="page-link"> Siguiente </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div :class="[mostrarTablaUsuarios ? 'd-flex justify-content-between' : 'd-flex justify-content-end']" style="margin-top: 2em;">
                                <button v-if="mostrarTablaUsuarios" class="btn btn-primary" @click="regresarVistaAnterior"><i class="fas fa-long-arrow-alt-left"></i></button>
                                <button v-if="!mostrarTablaUsuarios" class="btn btn-primary" @click="eventoGuardarNotififcador"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import catalogos from '@/../static/js/catalogos'
import sistemas from '@/../static/js/sistemas'
import comun from "@/../static/js/comun"
import api from '@/../static/js/api'
import axios from 'axios'

export default {
    components: {
        CTablaGenericaCedulas: sistemas.SINOJ.CTablaGenericaCedulas,
        C021Zonas: catalogos.SINOJ.C021Zonas,
        C001Area: catalogos.PJ.C001Area
    },
    data() {
        return {            
            esOrdenDeProteccion: false,
            esDireccionCiviles: false,
            enumeraciones,
            nombreFiltro: null,
            zonaFiltro: '-1',
            apellidoPaternoFiltro: null,
            apellidoMaternoFiltro: null,
            ID_TABLA_NOTIFICADORES: 'tablaAdministracionNotificadores',
            encabezadosColumnas: ['Folio','Nombre','Apellido paterno','Apellido materno','Zona','Estatus',''],
            TABLA_NOTIFICADORES_ACCIONES: {motrarAcciones: true,check: false, eliminar: true, editar: true,imprimir: false, ver: false},
            listaDeNotificadores: [],
            listaDeNotificadoresBD: [],
            nombreNotificador: null,
            apellidoPaterno: null,
            apellidoMaterno: null,
            zonaAsignada: '-1',
            direccion: '-1',
            modoEdicion: false,
            estatusNotificador: '1',
            mostrarTablaUsuarios: false,
            personal:[],
            personasEncontradas: [],
            notificadorSeleccionado: null,
            pagina: 1,
            numeroDePaginas: [],
            partesAmostrarPorPagina: 5,
            tipoZonaId: -1,
            tipoAreaId: -1,
            contadorRenderCatalogos: 0,
            ocultarCatalogo: false,
            mostrarErroresFormularioAlta: false,
            mensajeErrorFormularioAlta: 'Se detectaron campos incorrectos, por favor ingrese un valor válido.',
            areaNoticadorEsValida: false,
            mostrarAvisoErrores: false,
            cargandoNotificadores: true,
            personas: [],
            areaEsInformativa: false,
            tablaNotificadores: {
                buscarPor: null
            },
            usuarioEsDeJuzgadoMixto: false
        }
    },
    methods: {
        cambioTipoDeZona: function(evento) {
            //console.log('cabioTipoZona::',evento);
            //console.log('obtenerCatalogoZona::',this.obtenerCatalogoZona);
        },
        eventoFiltrarNotificadores: function() {
             this.cargarNotificadoresRegistradasBD();
        },
        cambioDeAreaAlta: function(evento) {
            let areaId = this.obtenerCatalogoArea.TipoAreaAltaNotificador
            this.areaNoticadorEsValida = this.areaDeNotificadorValida();
        },
        agregarNotificador: async function(conFormulario = false) {
            await Promise.resolve(this.asignarValoresEnCatalogos(this.$store.state.Login_Usuario.Area));
            this.modoEdicion = false;
            if(conFormulario)
                $('#formularo-notificador').modal('show');
        },
        editarNotificador: function(evento) {
            this.notificadorSeleccionado = this.obtenerNotificadorSeleccionado(evento);
            this.asignarDatosEdicionEnFormulario(this.notificadorSeleccionado);
            this.areaEsInformativa = true;
            this.modoEdicion = true;
            //console.log(evento.target.getAttribute('id'));
            $('#formularo-notificador').modal('show');
        },
        editarNotificadorBD: function(notificador) {
            const SERVIDOR = api.conexion;
            const METODO_API_EDITAR = api.SINOJ.sistema.administracion.notificadores.EditarNotififcador;
            let urlApi = SERVIDOR + METODO_API_EDITAR;
            let peticionArchivos = false;
            let peticionAPI = {};
            peticionAPI.esPrueba = false;
            peticionAPI.NotificadorId = this.notificadorSeleccionado.NotificadorId;
            peticionAPI.ZonaId = (this.obtenerCatalogoZona.catalogoZonasNotificadoresAlta < 0) ? null : this.obtenerCatalogoZona.catalogoZonasNotificadoresAlta;
            peticionAPI.EsDeOrdenProtecion = this.esOrdenDeProteccion;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            $('#btn-cerrar-formulario-alta-notificador').trigger('click');
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            //console.log("ejecuto bien :: " + respuesta.data);
                            this.cargandoNotificadores = true;
                            this.cargarNotificadoresRegistradasBD();
                            this.limpiarVariablesFormularioAlta();
                            comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                        }
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        asignarDatosEdicionEnFormulario: function(notificador) {
            const JUZGADOS_DONDE_TRABAJA = notificador.Usuario.JuzgadosDondeTrabaja;
            let areaDelNotificador = -1;
            if(JUZGADOS_DONDE_TRABAJA != null && JUZGADOS_DONDE_TRABAJA.length > 0) {
                areaDelNotificador = JUZGADOS_DONDE_TRABAJA[0].AreaId;
            }
            this.tipoAreaId = areaDelNotificador;
            this.nombreNotificador = notificador.Usuario.Nombre;
            this.apellidoPaterno = notificador.Usuario.ApellidoPaterno;
            this.apellidoMaterno = notificador.Usuario.ApellidoMaterno;
            this.tipoZonaId = (notificador.Zona != null) ? notificador.Zona.ZonaId : -1;
            this.esOrdenDeProteccion = notificador.EsOrdenDeProteccion;
            this.contadorRenderCatalogos ++;
            $("#nombreF").attr('disabled','disabled');
            $("#apellidoPF").attr('disabled','disabled');
            $("#apellidoMF").attr('disabled','disabled');
            /* this.estatusNotificador = (notificador.Activo) ? 1 : 0; */
        },
        eventoEliminarNotificador: function(evento) {
            const NOTIFICADOR = this.obtenerNotificadorSeleccionado(evento);
            let peticion = {};
            peticion.esPrueba = false;
            peticion.Notificador = NOTIFICADOR;
            const NOMBRES = [NOTIFICADOR.Usuario.Nombre,NOTIFICADOR.Usuario.ApellidoPaterno,NOTIFICADOR.Usuario.ApellidoMaterno];
            const NOMBRE_COMPLETO = NOMBRES.join(" ");
            this.informarConfirmacionDeEliminar(NOMBRE_COMPLETO, peticion);
        },
        eliminarNoticadorBD: function(peticionAPI) {
            const SERVIDOR = api.conexion;
            const METODO_API_AGREGAR = api.SINOJ.sistema.administracion.notificadores.EliminarNotififcador;
            let urlApi = SERVIDOR + METODO_API_AGREGAR;
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            //console.log("ejecuto bien :: " + respuesta.data);
                            this.cargandoNotificadores = true;
                            this.cargarNotificadoresRegistradasBD();
                            comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                        }
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        obtenerNotificadorSeleccionado: function(evento) {
            let notificador = null;
            const notificadorSeleccionado = evento.target.getAttribute('id');
            const idNotificador = parseInt(this.obtenerIdNotificadorTabla(notificadorSeleccionado));
            this.listaDeNotificadoresBD.filter(nb => nb.NotificadorId == idNotificador).forEach(n => {
                notificador = n;
            });
            return notificador;
        },
        obtenerIdNotificadorTabla: function(notificadorSeleccionado) {
            const notificador = notificadorSeleccionado.split('-');
            const posicionDeId = (notificador.length - 1);
            const idNotificador = notificador[posicionDeId];
            return idNotificador;
        },
        regresarVistaAnterior: function() {
            this.mostrarTablaUsuarios = false;
        },
        contenidoColumnasPersonal: function(parte) {
            let camposParte = Object.values(parte);
            let contenido = camposParte.splice(1,camposParte.length - 1);
            return contenido;
        },
        eventoGuardarNotififcador: function() {
            if(this.modoEdicion) {
                this.editarNotificadorBD();
            }
            else {
                this.registrarNuevoNotificador();
            }
        },
        registrarNuevoNotificador: function() { debugger
            if(this.validacionFormularioAlta(true,true)) {
                this.guardarNuevoNotificadorBD();
                /* if(this.personas.length > 0 && !this.modoEdicion) {
                    this.pagina = 1;
                    // this.mostrarTablaUsuarios = true;
                    this.$nextTick(() => {
                        $("#tablaUsuarios input[type='checkbox']").prop('checked', false);
                        $("#" + 'paginacion-tabla-personal-notificadores ' + "li").removeClass('active');
                        $("#" + 'tabla-personal-notificadores'+ 'pagina' + this.pagina).addClass('active');
                        //$('#formularo-notificador').modal('show');
                    });
                    $('#formularo-notificador').modal('show');
                } */
            }
        },
        validacionFormularioAlta: function(conNombres,conArea) {
            let campos = [{input: this.nombreNotificador, nombreInput: 'Nombre'}, 
                          {input: this.apellidoPaterno, nombreInput: 'Apellido Paterno'}, 
                          {input: this.apellidoMaterno, nombreInput: 'Apellido Materno'}];
            let formularioValido = false;
            let errores = [];
            if(conArea) {
                if(!this.areaDeNotificadorValida()) {
                    this.mostrarErroresFormularioAlta = true;
                    this.mostrarAvisoErrores = true;
                    formularioValido = false;
                    this.mensajeErrorFormularioAlta = `Se detectaron campos Incorrectos, por favor revise el área a la que corresponde la persona`;
                    return formularioValido;
                }
            }

            if(conNombres) {
                for(let i=0; i<campos.length; i++) {
                    if(this.cadenaEsVaciaONula(campos[i].input)) {
                        this.mostrarErroresFormularioAlta = true;
                        this.mostrarAvisoErrores = true;
                        formularioValido = false;
                        errores.push(`Se detectaron campos Incorrectos, por favor revise la información de los campos Nombre, Apellido paterno y Apellido materno`);
                    }
                    else {
                        /* this.mostrarErroresFormularioAlta = false; */
                        this.mostrarAvisoErrores = this.areaNoticadorEsValida ? false: true;
                        formularioValido = true;
                        break;
                    }
                }
            }
            if(!this.areaNoticadorEsValida) {
                this.mensajeErrorFormularioAlta = `Se detectaron campos Incorrectos, por favor revise el área a la que corrsponde el notificador`;
            }
            else {
                this.mensajeErrorFormularioAlta = errores[0];
            }
            return formularioValido;
        },
        areaDeNotificadorValida: function() {
            let areaValida = true;
            let area = this.obtenerCatalogoArea.TipoAreaAltaNotificador;
            //console.log('areaDeNotificadorValida::',area);
            if(area == undefined || area == null || area == -1 ) {
                areaValida = false;
                this.mostrarAvisoErrores = true;
            }
            this.areaNoticadorEsValida = areaValida;
            return areaValida;
        },
        cadenaEsVaciaONula: function(cadena) {
            let esVaciaONula = false;
            if(cadena == null || cadena == '' || cadena == undefined) {
                esVaciaONula = true;
            }
            return esVaciaONula;
        },
        validacionesAltaNotificador: function() {
            let mensajeError = null;

        },
        guardarNuevoNotificadorBD: function() {
            const SERVIDOR = api.conexion;
            const METODO_API_AGREGAR = api.SINOJ.sistema.administracion.notificadores.GuardarNuevoNotificador;
            let urlApi = SERVIDOR + METODO_API_AGREGAR;
            let zonaId = this.obtenerCatalogoZona.catalogoZonasNotificadoresAlta;
            let peticionAPI = {
                Nombre: this.nombreNotificador,
                ApellidoPaterno: this.apellidoPaterno,
                ApellidoMaterno: this.apellidoMaterno,
                AreaId: this.obtenerCatalogoArea.TipoAreaAltaNotificador,
                ZonaId: (zonaId == undefined || zonaId == null || zonaId < 0 ) ? null : zonaId,
                EsDeOrdenProtecion: this.esOrdenDeProteccion
            };
            peticionAPI.esPrueba = false;
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            $('#btn-cerrar-formulario-alta-notificador').trigger('click');
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            this.mostrarErroresFormularioAlta = false;
                            this.mostrarAvisoErrores = false;
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            comun.SeEstaCargandoInformacion(false);
                            //console.log("obtenerUsuariosPorArea::ejecuto bien:: ",respuesta.data);
                            //$('#btn-agregar-nuevoNotififcador').trigger('click');
                            this.agregarNotificador(false);
                            if(respuesta.data.Usuarios.length > 1) {
                                this.personas = respuesta.data.Usuarios;
                                this.personasBDaPersonasObj();
                                this.mostrarTablaUsuarios = true;
                                if(this.personas.length > 0 && !this.modoEdicion) {
                                    this.pagina = 1;
                                    this.$nextTick(() => {
                                        $("#tablaUsuarios input[type='checkbox']").prop('checked', false);
                                        $("#" + 'paginacion-tabla-personal-notificadores ' + "li").removeClass('active');
                                        $("#" + 'tabla-personal-notificadores'+ 'pagina' + this.pagina).addClass('active');
                                        $('#formularo-notificador').modal('show');
                                    });
                                }
                            }
                            else if(respuesta.data.Notificador != null) {
                               // console.log('entroelseif');
                                $('#btn-cerrar-formulario-alta-notificador').trigger('click');
                                $('#formularo-notificador').modal('hide');
                                this.limpiarVariablesFormularioAlta();
                                comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                                this.cargandoNotificadores = true;
                                this.cargarNotificadoresRegistradasBD();
                            }
                        }
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        limpiarVariablesFormularioAlta: function() {
            this.nombreNotificador = null,
            this.apellidoPaterno = null,
            this.apellidoMaterno = null,
            this.ocultarCatalogo = false;
            this.tipoZonaId = -1;
            this.tipoAreaId = -1;
            this.contadorRenderCatalogos ++;
            this.mostrarTablaUsuarios = false;
            this.personal = false;
            $("#nombreF").removeAttr('disabled');
            $("#apellidoPF").removeAttr('disabled');
            $("#apellidoMF").removeAttr('disabled');
            this.mostrarErroresFormularioAlta = false;
            this.mostrarAvisoErrores = false;
            this.areaEsInformativa = false;
            this.esOrdenDeProteccion = false;
        },
        personasBDaPersonasObj: function() {
            this.personal = this.personas.map(p => {
                let persona = {};
                persona.id = p.IdUsuario;
                persona.nombre = p.Nombre;
                persona.apellidoPaterno = p.ApellidoPaterno;
                persona.apellidoMaterno = p.ApellidoMaterno;
                return persona;
            });
        },
        eventoNotificadorSeleccionada: function(evento) {
            const SELECCION_ID = evento.target.getAttribute('id');
            const ID_NOTIFICADOR = SELECCION_ID.split("-");
            const SELECCIONADA = $('#' + SELECCION_ID).is(":checked");
            this.notificadorSeleccionado = {idCheck: SELECCION_ID, id: ID_NOTIFICADOR[ID_NOTIFICADOR.length -1], seleccionado: SELECCIONADA}
            this.mostrarEstadoCheckbox();
            let idNotififcador = parseInt(ID_NOTIFICADOR[ID_NOTIFICADOR.length -1]);
            this.personal.filter(n => n.id == idNotififcador).forEach(notificador => {
                this.nombreNotificador = notificador.nombre;
                this.apellidoPaterno = notificador.apellidoPaterno;
                this.apellidoMaterno = notificador.apellidoMaterno;
            });
            this.mostrarTablaUsuarios = false;
        },
        mostrarEstadoCheckbox: function () {
            $("#tablaUsuarios input[type='checkbox']").prop('checked', false);
            if(this.notificadorSeleccionado != null) {
                $("#" + this.notificadorSeleccionado.idCheck).prop('checked', this.notificadorSeleccionado.seleccionado);
            }
        },
        cambioDePaginaConOpcion: function (evento) {
            const SELECCION_ID = evento.target.getAttribute('id');
            const ANTERIOR_ID = 'opcionInicio';
            const SIGUIENTE_ID = 'opcionSiguiente';

            if (SELECCION_ID === ANTERIOR_ID) {
            this.pagina--;
            }
            else if (SELECCION_ID === SIGUIENTE_ID) {
            this.pagina++;
            }
            this.$nextTick(() => {
                this.mostrarEstadoCheckbox();
                $("#" + 'paginacion-tabla-personal-notificadores ' + "li").removeClass('active');
                $("#" + 'tabla-personal-notificadores'+ 'pagina' + this.pagina).addClass('active');
            });
        },
         cambioDePaginaConPuntero: function (numeroDePagina) {
            this.pagina = numeroDePagina;
            this.$nextTick(() => {
                this.mostrarEstadoCheckbox();
                $("#" + 'paginacion-tabla-personal-notificadores ' + "li").removeClass('active');
                $("#" + 'tabla-personal-notificadores'+ 'pagina' + this.pagina).addClass('active');
            });
        },
         obtenerNumeroDePaginas: function () {
            //console.log("");
            let numeroDePaginas = Math.ceil(this.personal.length / this.partesAmostrarPorPagina);
            this.numeroDePaginas = [];
            this.pagina = 1;
            this.notificadorSel = {};
            for (let i = 1; i <= numeroDePaginas; i++) {
                this.numeroDePaginas.push(i);
            }
            this.$nextTick(() => {
                $("#" + 'paginacion-tabla-personal-notificadores ' + "li").removeClass('active');
                $("#" + 'tabla-personal-notificadores'+ 'pagina' + this.pagina).addClass('active');
            });
            
            this.mostrarEstadoCheckbox();
        },
        paginacionDePersonal: function(partes) {
            let pagina = this.pagina;
            let partesAmostrarPorPagina = this.partesAmostrarPorPagina;
            let desde = (pagina * partesAmostrarPorPagina) - partesAmostrarPorPagina;
            let hasta = (pagina * partesAmostrarPorPagina);
            return partes.slice(desde, hasta);
        },
        cargarNotificadoresRegistradasBD: function() {
            const SERVIDOR = api.conexion;
            const METODO_API_OBTENER = api.SINOJ.sistema.administracion.notificadores.ObtenerNotificadores;
            let urlApi = SERVIDOR + METODO_API_OBTENER;
            let peticionAPI = {
                ZonaId: (this.obtenerCatalogoZona.catalogoZonasNotificadoresFiltro < 0) ? null : this.obtenerCatalogoZona.catalogoZonasNotificadoresFiltro,
                Nombre: this.nombreFiltro,
                ApellidoPaterno: this.apellidoPaternoFiltro,
                ApellidoMaterno: this.apellidoMaternoFiltro,
                ConInactivos: false,
            };
            peticionAPI.esPrueba = false;
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            /* console.log("cargarNotificadoresRegistradasBD::ejecuto bien:: ",respuesta.data); */
                            this.listaDeNotificadoresBD = respuesta.data.Notificadores;

                            this.listaDeNotificadores = this.notififcadorBDaNotificadorObj();

                            //se agrega eventos para el filtro de busqueda en memoria de la tabla
                            this.$nextTick(() => {
                                $("#inputs-filtro-memoria input").on("change paste keyup", (e) => {
                                    if(this.listaDeNotificadoresBD.length > 0) {
                                        this.filtrarNotificadoresTabla(e);
                                    }
                                }); 
                            });
                        }
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        filtrarNotificadoresTabla: function(e) { 
            // filtra por columnas y nivel de prioridad
            this.listaDeNotificadores = this.notififcadorBDaNotificadorObj()
            .filter(c => {
                return Object.values(c).some(valorColumna => this.predicateFiltradoPorSimilitud(valorColumna, this.tablaNotificadores.buscarPor));
            });
        },
        predicateFiltradoPorSimilitud: function(elementoAEvaluar,compararCon) { 
            if(this.campoRequeridoEsValido(compararCon)) {
            if(this.campoRequeridoEsValido(elementoAEvaluar) && elementoAEvaluar.toString().toUpperCase().startsWith(compararCon.toString().toUpperCase()))
                return true;
            else
                return false;
            }
            else
                return true;
        },
        notififcadorBDaNotificadorObj: function() {
            let notificadores = [];
            this.listaDeNotificadoresBD.forEach(nBD => {
                let notificador = {};
                notificador.Folio = nBD.NotificadorId;
                notificador.Nombre = nBD.Usuario.Nombre;
                notificador.ApellidoPaterno = nBD.Usuario.ApellidoPaterno;
                notificador.ApellidoMaterno = nBD.Usuario.ApellidoMaterno;
                if(!this.usuarioEsDeJuzgadoMixto)
                    notificador.Zona = (nBD.Zona != null) ? nBD.Zona.Nombre : 'Sin Zona';
                if(this.esDireccionCiviles)
                    notificador.EsOrdenDeProteccion = (nBD.EsOrdenDeProteccion) ? 'Si' : 'No';
                notificador.Estatus = (nBD.Activo) ? 'Activo' : 'Inactivo';
                notificadores.push(notificador);
            });
            //this.listaDeNotificadores = notificadores;
            this.cargandoNotificadores = false;
            return notificadores;
            //console.log('notififcadorBDaNotificadorObj::',this.listaDeNotificadores);
        },
        /**
         * Metodo encargado de mostrar alerta bootbox para confirmacion. 
         * @param {object} notificador [notificador que se eliminara]
         * @see {@link eliminarNoticadorBD}
         */
        informarConfirmacionDeEliminar: function (notificador, peticion) {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: `Estas seguro que deseas eliminar al notificador '${notificador}'<br>¿Desea continuar?`,
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        this.eliminarNoticadorBD(peticion);
                    }
                }
            });
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        },
        asignarValoresEnCatalogos: async function(areaDeUsuario) { 
            //console.log('Area::',areaDeUsuario);
            if(this.campoRequeridoEsValido(areaDeUsuario)) {
                const { AreaId } = areaDeUsuario;
                this.tipoAreaId = this.campoRequeridoEsValido(AreaId) ? AreaId : -1;
                const VALOR_EVENTO = {
                    target: { value: this.tipoAreaId }
                };
                // se llama a funcion de evento correspondiente al catalogo de Area para que actualice los demas catalogos
                this.contadorRenderCatalogos ++;
                this.areaEsInformativa = true;
            }
            else {
                this.tipoAreaId = -1;
                const VALOR_EVENTO = {
                    target: { value: this.tipoAreaId }
                };
                this.contadorRenderCatalogos ++;
                this.areaEsInformativa = false;
            }
        },
        esJuzgadoMixto: function(areaDeUsuario) {
            
          if(this.campoRequeridoEsValido(areaDeUsuario)) {
              const { AreaId } = areaDeUsuario;
              const JUZGADOS_MIXTOS = Object.values(enumeraciones.sinoj.juzgadosMixtos);
              if(this.campoRequeridoEsValido(JUZGADOS_MIXTOS)) {
                const ES_JUZGADO_MIXTO = JUZGADOS_MIXTOS.some(jz => jz == AreaId);
                if(ES_JUZGADO_MIXTO) {
                  this.usuarioEsDeJuzgadoMixto = true;
                  this.encabezadosColumnas = ['Folio','Nombre','Apellido paterno','Apellido materno','Estatus',''];
                }
                else if(AreaId == enumeraciones.sinoj.direccionesNotificadores.Civiles){
                    this.esDireccionCiviles = true;
                    this.encabezadosColumnas = ['Folio','Nombre','Apellido paterno','Apellido materno','Zona','Es de Orden de Protección','Estatus',''];
                }
              }              
          }
      },
    },
    watch: {
      personal() {
        this.obtenerNumeroDePaginas();
      }
    },
    created() {
      this.cargarNotificadoresRegistradasBD();
      /* this.obtenerNumeroDePaginas(); */
      //console.log('valorLista::',this.listaDeNotificadores);
    },
    mounted() {
        this.esJuzgadoMixto(this.$store.state.Login_Usuario.Area);
    },
    computed: {
      obtenerPaginacionDePersonal() {
        return this.paginacionDePersonal(this.personal);
      },
      obtenerCatalogoZona() {
        return this.$store.getters.Get_SINOJ_Catalogos_021Zonas;
      },
      obtenerCatalogoArea() {
        return this.$store.getters.Get_PJ_Catalogos_001Area;
      }
    }
}
</script>
<style scoped>
#inputs-filtro-memoria .form-control {
    background-color:rgb(202, 202, 202) !important;
    color: #1b1919 !important;
}


#contendor-principal-notificadores .card-body {
    background-color: rgb(49, 49, 49);
}

#contendor-principal-notificadores .card {
    border: 1px solid rgb(129, 129, 129) !important;
}

#contendor-principal-notificadores .card-header {
    background-color: rgb(70, 70, 70);
}

#encabezados-tp {
    margin-bottom: 1em;
}

#encabezados-tp h1 {
    margin-bottom: 0;
    font-weight: bold;
}

#encabezados-tp h4 {
    font-size: 1.5em;
    color: rgb(214, 214, 214);
}

.hr-titulo {
    height:0.5em;
    width: 6em;
    border:none;
    background-color:#ffffff;
}

#f-busqueda {
    width: 20em;
}

#contendor-notificadores {
    display: flex;
    justify-content: center;
}

@media only screen and (max-width: 900px) {
    #contenedor-opciones-busqueda {
         flex-direction: column !important;
    }

    #contenedor-opciones-busqueda div {
         width: 100% !important;

    }
}

.contenedor-color-negro {
    padding: 1.5em;
    background-color: #2c2d31;
    box-shadow: 0px 6px 20px 8px #161616;
    border-radius: 6px;
}

#contenedor-opciones-busqueda {
    display: flex;
    margin-top: 1em;
}

.btn-primary {
    color: white;
    background-color: rgb(36, 34, 34);
    border-color: white;
}

.btn-primary:hover {
    color: white;
    background-color: black;
    border-color: white;
}

#titulo-tabla {
    background-color: #1b1919;
    margin-top:1em;
    padding: 5px 15px 10px 15px;
    margin-bottom: 0px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    /* display: flex;
    justify-content: space-between; */
}

.modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

.btn-primary:focus {
    color: white;
    background-color: black;
    border-color: white;
    box-shadow: none;;
}

.pagination > li > button:focus {
    color: white;
    background-color: #3c3d41;
    border-color: black;
    box-shadow: none;
  }

  .pagination > .active > button {
    color: white;
    background-color: #3c3d41;
    border-color: black;
    box-shadow: none;
  }

  .pagina-seleccionada {
    color: white;
    background-color: #3c3d41;
    border-color: black;
    box-shadow: none;
  }

  .pagination > li > button {
    color: white;
    background-color: grey;
    border-color: black;
  }

    .pagination > li > button[id^="opcion"] {
        color: white;
        background-color: #26272b;
        border-color: black;
    }

  .pagination {
    margin: 0px !important;
  }

    #tablaUsuarios {
        border-collapse: collapse;
        width: 100%;
        background-color: #26272b;
    }

    #tablaUsuarios th {
        position: sticky;
        top: 0;
        background: #474749;
        border: 1;
    }

    #tablaUsuarios td {
        color: white;
    }


    #tablaUsuarios tbody {
        height: 10px;
    }

    .catalogoInformativo {
        pointer-events:none;
        cursor: not-allowed;
        opacity: 0.5;
    }

    .contenedor-sin-notificadores {
        background-color: rgb(36, 34, 34);
        height: 40px;
        height: 21rem;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    #contenedor-error-formulario {
        padding: 1em;
        background-color: #26272b;
        border: 1px solid #5c5959;
        border-radius: 8px;
        margin-bottom: 1em;;
    }

    .contenedor-cargando {
        background-color: rgb(36, 34, 34);
        height: 40px;
        height: 21rem;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    #encabezado-contenedor-contenido {
        background-color: rgb(44, 43, 43);
        padding: 10px;
    }

    #formularo-notificador .modal-lg {
        max-width: 40% !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Administracion/Notificadores/CNotificadores.vue